class QuotationFormInitialController {
    /** @ngInject */
    constructor($timeout, DeviceChecker) {
        this.$timeout = $timeout
        this.isMobile = DeviceChecker.isMobile
        this.popoverIsOpen = false
    }

    goToStepLandscape() {
        this.onDispatch({ $event: { type: 'GO_TO_FORM_LANDSCAPE', origin: 'FORM_INITIAL_BTN_DEMARRER' } })
    }

    goToStepConsumption() {
        this.onDispatch({ $event: { type: 'GO_TO_FORM_CONSUMPTION', origin: 'FORM_INITIAL_BTN_BYPASS' } })
    }

    onIconQuestionMarkClick() {
        const that = this
        this.$timeout(() => {
            if (that.popoverIsOpen) {
                that.onDispatch({ $event: { type: 'CLICK_ON_QUESTION_MARK_FORM_INITIAL' } })
            }
        })
    }
}

export default {
    template: require('./quotationFormInitial.jade')(),
    controller: QuotationFormInitialController,
    bindings: {
        store: '<',
        onDispatch: '&',
    },
}



// WEBPACK FOOTER //
// ./src/states/quotation/component/quotationFormInitial.js